import Head from 'next/head';
import * as React from 'react';
import { useTheme } from '@/themes';
import Error404 from '../pages/404';
import { env } from '@zopauk/nextjs-env';
import type { NextPageContext } from 'next';
import type { ErrorProps } from 'next/error';
import { default as NextError } from 'next/error';
import { MainCobrandedLegalCopy } from './cancelled';
import { pageTitles } from '@/utils/copy/page-titles';
import { FullPageLayout } from '@/components/FullPageLayout';
import { ErrorPageTemplate, breakpoints } from '@zopauk/react-components';

const ZopaError = ({ statusCode }: ErrorProps) => {
  const { partnerName } = useTheme();

  return (
    <>
      <Head>
        <title>{pageTitles.error500}</title>
      </Head>
      <FullPageLayout
        mainCobrandedLegalCopy={partnerName === 'jl-money' ? <MainCobrandedLegalCopy /> : null}
        isCobranded={partnerName === 'jl-money'}
        maxWidth={breakpoints.desktop}
      >
        <ErrorPageTemplate>
          {statusCode === 404 ? (
            <Error404 />
          ) : (
            <ErrorPageTemplate.FiveHundred
              linkUrl={`${env('NEXT_PUBLIC_HOMEPAGE_URL')}/loans`}
              isCobranded={partnerName === 'jl-money'}
            />
          )}
        </ErrorPageTemplate>
      </FullPageLayout>
    </>
  );
};

ZopaError.getInitialProps = async (contextData: NextPageContext) => NextError.getInitialProps(contextData);

export default ZopaError;
